import React, { useEffect, useMemo, useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { signUpWithGoogle } from "../utils/firebase.utils";
import FormikForm from "../components/commonForm";
import {
  feildsLogin,
  initialValuesLogin,
  validationSchemaLogin,
} from "../fromsUtil/login.form";
import { logOut, login, loginAdmin, loginGoogle } from "../logic/login/action";
import { useDispatch, useSelector } from "react-redux";
import logo from "../images/logo_clock.png";
import { toast } from "react-toastify";
import { RWebShare } from "react-web-share";
import { ShareSocial } from "react-share-social";
import { CircularProgress } from "@mui/material";

const AdminLogin = () => {
  const route = useLocation();
  const nav = useNavigate();

  const superadmin = useMemo(() => {
    const dt = new URLSearchParams(route.search);
    if (dt.get("superadmin")) {
      return true;
    } else {
      return false;
    }
  }, [route.search]);

  useEffect(() => {
    console.log(superadmin, "how many");
    if (superadmin && type !== "admin") {
      settype("admin");
    }
  }, [superadmin]);

  const [type, settype] = useState("admin");

  const dispatch = useDispatch();
  const onSubmit = async (values, submitProps) => {
    await loginAdmin(dispatch, values, "admin", nav);
    submitProps.setSubmitting(false);
    submitProps.resetForm();
  };
  const selectorAuth = useSelector(state=>state.auth);

  return (
    <div className="w-screen relative bg-white h-auto flex flex-col items-center justify-center">
      {
        selectorAuth.status === 'loading'?
        <div className="w-screen z-20 h-screen bg-secondry/30 fixed top-0 left-0 flex items-center justify-center">
        <CircularProgress color="primary"/>
      </div>:<></>
      }
      <div className="bg-secondry/5 w-full">
        <header className="w-full lg:w-[80%] mx-auto flex items-center py-4 justify-between px-4">
          <a href="/">
            <img src={logo} className="w-20 h-20"></img>
          </a>
          <div className="flex items-center gap-2">
            <p className="hidden lg:inline-block">Need an account?</p>
            <Link to={"/admin/register"} onClick={() => logOut(dispatch)}>
              <p className="text-secondry border-b border-b-secondry">
                Sign Up
              </p>
            </Link>
          </div>
        </header>
      </div>
      <div className="bg-secondry/5 w-full">
        <div className="w-full  lg:w-[80%] mx-auto flex justify-center items-start gap-4 min-h-screen">
          <div className="flex-1 min-w-full lg:min-w-[45%] h-full p-4 lg:p-0 relative">
            <div className="bg-white shadow-2xl shadow-gray-200 rounded-lg w-full lg:w-[40%] mx-auto flex flex-col gap-4 lg:gap-8 p-4 lg:p-16">
              <h2 className="font-normal text-xl">Admin Login</h2>

              <FormikForm
                initialValues={initialValuesLogin}
                fields={feildsLogin}
                validationSchema={validationSchemaLogin}
                action={(disabled) => (
                  <button
                    disabled={disabled}
                    className="button w-full"
                    type="submit"
                  >
                    Login
                  </button>
                )}
                onSubmit={onSubmit}
              />
              {/* <button></button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
